
import { CommonModule } from '@angular/common';
import {CardTableComponent} from './card-table.component';
import { CustomElementService } from '@formbird/services';
import { CUSTOM_ELEMENTS_SCHEMA, Injector, NgModule } from '@angular/core';
import { default as pjson } from '../../../../../package.json';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import {MatExpansionModule} from '@angular/material/expansion';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';


@NgModule({
  declarations: [
    CardTableComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    DragDropModule,
    MatProgressSpinnerModule,
    MatCardModule,
    MatFormFieldModule,
    MatExpansionModule,
    FormsModule,
    MatIconModule,
    MatInputModule
   ],
  providers: []
  // do not bootstrap the app component when exporting custom elements because an Angular app doesn't run. An ngDoBootstrap
  // function is defined that does nothing.
  // bootstrap: [AppComponent]
})
export class CardTableModule {
  constructor(private injector: Injector, private customElementService: CustomElementService) {
    customElementService.convertToCustomElement(CardTableComponent, 'sc-card-table', this.injector, pjson.version);

  }
}